export default __webpack_public_path__ + "static/media/Catherine 9781408339466.0963d0e8.jpg";